"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var assets_1 = require("../../assets");
var SIZE_MAP = {
    sm: 64,
    md: 80,
};
var SecondaryIllustration = function (_a) {
    var type = _a.type, actionable = _a.actionable, size = _a.size;
    var altText = actionable ? type + " actionable" : type;
    var illustrationMap = actionable
        ? assets_1.ActionableSecondaryIllustrationAsset
        : assets_1.SecondaryIllustrationAsset;
    return (react_1.jsx("img", { width: SIZE_MAP[size], height: SIZE_MAP[size], alt: altText, src: illustrationMap[type] }));
};
exports.default = SecondaryIllustration;
